import { liveMatches, upcomingMatches } from '@/mocks/matches';

export default function LiveMatches() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            实时赛事
          </h2>
          <p className="text-sm text-foreground-600 mt-1">正在进行的精彩对决</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse"></span>
          <span className="text-sm text-red-500 font-medium">直播中</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
        {liveMatches.map((match) => (
          <div
            key={match.id}
            className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-colors cursor-pointer"
          >
            <div className="flex items-center justify-between mb-4">
              <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full">
                {match.league}
              </span>
              <span className="text-xs text-red-500 font-medium flex items-center gap-1">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
                {match.time}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <div className="text-center flex-1">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-2 rounded-full bg-background-100">
                  <i className={`${match.homeLogo} text-2xl text-foreground-600`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-900 block">{match.homeTeam}</span>
              </div>
              <div className="flex items-center gap-2 px-3">
                <span className="text-2xl font-heading font-bold text-primary-600">
                  {match.homeScore}
                </span>
                <span className="text-lg text-foreground-400">:</span>
                <span className="text-2xl font-heading font-bold text-foreground-900">
                  {match.awayScore}
                </span>
              </div>
              <div className="text-center flex-1">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-2 rounded-full bg-background-100">
                  <i className={`${match.awayLogo} text-2xl text-foreground-600`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-900 block">{match.awayTeam}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mb-4">
        <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">即将开始</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
          {upcomingMatches.map((match) => (
            <div
              key={match.id}
              className="bg-background-100/70 border border-background-200/70 rounded-lg p-4 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs text-foreground-500">{match.league}</span>
                <span className="text-xs text-accent-600 font-medium">{match.time}</span>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200">
                    <i className={`${match.homeLogo} text-sm text-foreground-500`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{match.homeTeam}</span>
                </div>
                <span className="text-xs text-foreground-400 font-medium mx-2">VS</span>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-800">{match.awayTeam}</span>
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200">
                    <i className={`${match.awayLogo} text-sm text-foreground-500`}></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}